export default "__VITE_ASSET__DEqU8cWD__"